import CommonDashboardMaterialsController from 'ilios-common/controllers/dashboard/materials';

export default class DashboardMaterialsController extends CommonDashboardMaterialsController {}
